import React from 'react';
import { Link } from 'react-router-dom';
import './JourneyNextTip.css';

/**
 * One quiet line. Not a second CTA banner. Not a stage gate.
 * The step is a link (tip.to) or, when it needs a call first, a button (onAction).
 */
export default function JourneyNextTip({ tip, onAction }) {
  if (!tip?.text && !tip?.action) return null;
  let step = null;
  if (tip.action && tip.to) {
    step = <Link className="journey-next-tip__link" to={tip.to}>{tip.action}</Link>;
  } else if (tip.action && onAction && (tip.sequence || tip.sceneId)) {
    step = (
      <button type="button" className="journey-next-tip__link journey-next-tip__btn" onClick={() => onAction(tip)}>
        {tip.action}
      </button>
    );
  } else if (tip.action) {
    step = <span>{tip.action}</span>;
  }
  return (
    <p className={`journey-next-tip${tip.sequence || tip.sceneId || onAction ? ' journey-next-tip--path' : ''}`} role="status">
      {tip.text}
      {step ? (
        <>
          {tip.text ? ' ' : null}
          {step}
        </>
      ) : null}
    </p>
  );
}
